<template>
    <div class="bg-primary tpl-light">
      <template-header :show-actions="showActions" :navbar-type="navbarType" />
      <div id="page-content">
        <slot/>
      </div>
    </div>
    <template-footer/>
</template>
<script setup lang="ts">
// Fornisci il valore di hideAction a tutte le pagine
const showActions = ref(false)
const navbarType = ref('dark')
provide('showActions', showActions)
provide('navbarType', navbarType)
</script>

<style lang="scss">
.tpl-light{
  color: #000000;
}
</style>